import axios from './axios'
import generateService from './generator'

const endpoint = 'patient/me/therapies';

const base = generateService(endpoint);

function fetchActive() {
    return axios.get(`${endpoint}/active`).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function abort(id) {
    return axios.post(`${endpoint}/${id}/abort`).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function storeUser(data) {
    return axios.post(`${endpoint}/user`, data).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

function instantiateTemplate(templateId, data) {
    return axios.post(`${endpoint}/from-template/${templateId}`, data).then(response => {
        return response.data;
    }).catch(e => {
        throw e
    });
}

export default {
    fetchList: base.fetchList,
    fetchAll: base.fetchAll,
    fetchItem: base.fetchItem,
    fetchActive,
    abort,
    storeUser,
    instantiateTemplate
}
